/**
 * spaceLootConstants.ts
 * Tuning knobs for the World 2 enemy-loot pickup primitive (Star Seeds
 * dropped on enemy death).
 *
 * Pickups mirror the {@link ../game/entities/SpaceShard.SpaceShard}
 * shape — pooled, world-space stationary, ship collects on contact —
 * but spawn dynamically on enemy kill instead of from a level config.
 * Collected ids accumulate in a per-session list and get merged into
 * the save's `levels[levelId].collectedStarSeedIds` array on level
 * clear (same path as W1 star seeds).
 *
 * @module spaceLootConstants
 */

/** Greybox hitbox width (logical px). */
export const SPACE_STAR_SEED_WIDTH_PX = 16;

/** Greybox hitbox height (logical px). */
export const SPACE_STAR_SEED_HEIGHT_PX = 16;

/**
 * Pool cap. W2 main levels run 36-enemy scripts at most, but only
 * ~30% of kills drop loot and pickups self-reap once the camera passes
 * them, so a 16-slot pool is plenty of headroom.
 */
export const SPACE_STAR_SEED_POOL_CAP = 16;

/**
 * Probability (0..1) that an enemy kill drops a Star Seed. Tuned to
 * give the player a steady but non-overwhelming stream of pickups —
 * roughly 10 / 36 enemy kills in a 2-4 run.
 */
export const SPACE_STAR_SEED_DROP_CHANCE = 0.3;

/**
 * Pixels of camera-left margin past which an uncollected pickup is
 * culled. Mirrors {@link ../constants/spaceShardConstants.SPACE_SHARD_OFFSCREEN_MARGIN_PX}.
 */
export const SPACE_STAR_SEED_OFFSCREEN_MARGIN_PX = 64;

/**
 * Greybox body fill. Matches {@link ../constants/colors.COLORS.GOLD}
 * inline so the rendering folder doesn't need a new constants import
 * just for this colour. Promote to `COLORS` the moment a second caller
 * appears.
 */
export const SPACE_STAR_SEED_COLOR = '#f5c842';
